export default [
    {
        path: "/codigoServicoG4",
        name: "CodigoServicoG4",
        component: () => import("../views/CodigoServicoG4"),
        meta: { requiresAuth: true },
    }
]